module.exports = __webpack_public_path__ + "img/join3-5.4430855f.png";